import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

const typesWithEsente = Object.freeze([
  {
    id: 'E',
    value: 'Esente',
  },
  {
    id: 'C',
    value: 'Contanti',
  },
  {
    id: 'P',
    value: 'POS',
  },
]);

const types = Object.freeze([
  {
    id: 'C',
    value: 'Contanti',
  },
  {
    id: 'P',
    value: 'POS',
  },
]);

interface TypePaymentProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  label?: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  errorMessage?: string;
  withEsente?: boolean;
}

const TypePaymentComponent = ({
  disabled = false,
  onChange,
  required = false,
  value,
  label = 'Tipo pagamento',
  error = false,
  withEsente = false,
}: TypePaymentProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="type-payment-label">
        {required ? `${label} *` : `${label}`}
      </InputLabel>
      <PmiSelect
        labelId="type-payment-label"
        id="type-payment"
        name="type-payment"
        value={value}
        label={required ? `${label} *` : `${label}`}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {(withEsente ? typesWithEsente : types).map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

TypePaymentComponent.displayName = 'List type payment anpr component';

const TypePaymentList = memo(TypePaymentComponent);

export default TypePaymentList as typeof TypePaymentComponent;
